export const enCommonTranslates = {
  // Party
  createParty: 'Personal Information',
  personalDetails: 'Personal Information',
  partyType: 'Party type',
  successFillUserData: 'Successfully filled personal data',
  successUpdatedPartyQuestionnaireData: 'Successfully updated personal details',
  firstName: 'First name',
  lastName: 'Last name',
  requiredField: 'Required field',
  questionnaireSet: 'Questionnaire set',
  EndFilling: 'End filling',
  StartFill: 'Start fill',

  // Party case
  SuccessfullySubmittedPartyCase: 'Submitted party case successfully',
  YourPartyCaseWillBeProcessed: 'Your case will be processed',

  // Questionnaire fields
  none: 'None',
  middleName: 'Middle name',
  parentName: 'Parent name',
  personalId: 'Personal ID',
  dateOfBirth: 'Date of birth',
  placeOfBirth: 'Place of birth',
  stateOfBirth: 'State of birth',
  countryOfBirth: 'Country of birth',
  countryOfIdIssue: 'Country of ID issue',
  idNumber: 'ID number',
  idType: 'ID type',
  idIssuer: 'ID issuer',
  idDateOfIssue: 'ID date of issue',
  idExpiryDate: 'ID expiry date',
  idPermanent: 'ID permanent',
  cityOfResidence: 'City of residence',
  zip: 'ZIP',
  countryOfResidence: 'Country of residence',
  mailingAddress: 'Mailing address',
  email: 'Email',
  resident: 'Resident',
  citizenship: 'Citizenship',
  streetName: 'Street name',
  place: 'Place',
  addressType: 'Address type',
  residenceNumber: 'Residence number',
  stateOfResidence: 'State of residence',
  phoneNumber: 'Phone number',
  mobileNumber: 'Mobile number',
  additionalNote: 'Additional note',
  maternalName: 'Maternal name',
  occupation: 'Occupation',

  // PredefinedRegEx enum
  EMAIL: 'Email',
  PHONE: 'Phone',
  JMBG: 'JMBG',
  REGISTRATION_NUMBER: 'Registration number',
  VAT_NUMBER: 'VAT number',
  WEB_PAGE: 'Web page',
  CUSTOM: 'Custom',

  // Validation mode enum
  IN_THE_PAST: 'In the past',
  IN_THE_FUTURE: 'In the future',

  // List dynamic source
  SR_CITY_LIST: 'SR city list',
  COUNTRY_LIST: 'Country list',
  NACE_CODE_LIST: 'NACE code list',
  BUSINESS_TYPE: 'Business type',
  BUSINESS_INDUSTRY: 'Business industry',
  ID_TYPES: 'ID types',
  ADDRESS_TYPES: 'Address types',

  // Question mode enum
  ALL: 'All',
  AT_LEAST_ONE: 'At least one',

  // Label mode
  DESCRIPTION: 'Description',
  TITLE: 'Title',
  SUBTITLE: 'Subtitle',
  TITLE_SUBTITLE: 'Title and subtitle',

  companyName: 'Company name',
  shortName: 'Short name',
  tradeName: 'Trade name',
  typeOfLegalEntity: 'Type of legal entity',
  companyRegistrationNumber: 'Registration number',
  taxNumber: 'Tax number',
  registeredActivity: 'Registered activity',
  registrationDate: 'Registration date',
  stateOfRegistration: 'State of registration',
  countryOfRegistration: 'Country of registration',
  numberOfYearsInBusiness: 'Number of years in business',
  industry: 'Industry',
  registrationAddress: 'Registration address',
  city: 'City',
  postalCode: 'Postal code',
  primaryPhoneNumber: 'Primary phone number',
  webSite: 'Web site',
  ownerType: 'Owner type',
  SOLE_PROPRIETORSHIP: 'Sole proprietorship',
  PRIVATELY_HELD: 'Privately held',
  PUBLICLY_TRADED: 'Publicly traded',
  GOVERNMENT_OWNED: 'Government owned',
  OTHER_HYBRID: 'Other hybrid',
  businessType: 'Business type',
  category: 'Category',
  statisticalGroup: 'Statistical group',
  businessTypeOfClient: 'Business type of client',
  businessInvolvedInFollowingIndustries: 'Business involved in following industries',
  typeOfRelationship: 'Type of relationship',

  AssessmentIsPassed: 'Assessment is passed.',
  ErrorNotEnoughPoints: "You haven't scored enough points to pass the assessment.",
  ErrorNotOnTime: 'Warning! Time is up, and the test has ended.',

  dateMustBeInFuture: 'Date must be in future',
  dateMustBeInPast: 'Date must be in past',

  UndefinedIdDocument: 'Undefined document',
  ID: 'ID',
  Passport: 'Passport',
  Refugee_ID: 'Refugee ID',
  Asylum_Seeker_ID: 'Asylum Seeker ID',
  Refugee_Travel_Document: 'Refugee Travel Document',
  Diplomatic_ID: 'Diplomatic ID',
  Emergency_Travel_Document: 'Emergency Travel Document',
  Military_Identification_Card: 'Military Identification Card',
  Convict_Identification_Card: 'Convict Identification Card',
  Foreign_ID: 'Foreign ID',
  ID_Foreign_Citizen: 'ID Foreign Citizen',
  Driving_Licence: 'Driving Licence',
};
